import React, { PureComponent } from "react";
import "./service.css";

export default class ServiceTag extends PureComponent {
    static get propTypes() {
        return {
            name: React.PropTypes.string.isRequired,

        };
    }

    render() {
        return (
            <div className="appointment-service-tag">
                <div className="appointment-service-tag__name">
                    {this.props.name}
                </div>
            </div>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/components/servise-tag.js
 **/